import DefaultLayout from './defaultLayout.js';

export default DefaultLayout;
